const insertScripts = (scripts: string[]): void => {
  scripts.forEach(script => {
    const jsScript = document.createElement('script');
    jsScript.src = script;
    jsScript.async = true;
    jsScript.setAttribute('onload', 'loaded=true;');
    document.head.appendChild(jsScript);
  });
};

export default insertScripts;
